import * as z from "zod";

export const getYofiJwt = {
  name: "getYofiJwt" as const,
  input: z.object({}),
  output: z.object({ token: z.string() }),
};
